<template>
  <v-layout class="navmenu-container" justify-center align-center>
    <div class="progress-container">
      <!-- <div class="page-count">
        <span><strong>{{screenTrack[0]+1}}</strong> / <strong>{{screenTrack[1]}}</strong></span>
      </div> -->
      <div class="contenedor-progress-bar">
        <div class="progress-bar">
          <div ref="progressBar" class="bar"></div>
          <div ref="progressBar2" class="triangulo" ></div>
        </div>
      </div>
    </div>

    <!-- v-show="screenTrack[0] >= 1"  -->
    <button class="btn-nav" :class="{'inactive': !screenTrack[0] >= 1}">
      <router-link  class="kd kd-l" :to="'/'+mod.modurl+'/'+ (screenTrack[0]-1)"
                    @click.native.prevent="guardarubicacion()"
        >
        <!--<v-icon class="icon animated fadeInLeft" medium style="font-size:40px;">keyboard_arrow_left</v-icon>-->
        <!--<img class="arrow-icon" :src="require('../assets/imagenes_compartidas/arrow-left.png')" alt="">-->
        <div class="arrow-icon-component"><arrow-left/></div>
        <span class="color-primary txt-icon"></span>
      </router-link>
    </button>
    <!-- v-show="nextPant" -->
    <button class="btn-nav"  :class="[{'inactive': !nextPant}, {'animated bounceIn':nextPant}]">
      <router-link  class="kd kd-r" :to="'/'+mod.modurl+'/'+ (screenTrack[0]+1)"
                    @click.native.prevent="guardarubicacion()"
        >
        <span class="color-primary txt-icon"></span>
        <!--<v-icon class="icon animated fadeInRight" :class="{'anima-icon':nextPant}" medium style="font-size:40px;">keyboard_arrow_right</v-icon>-->
        <!--<img class="arrow-icon" :src="require('../assets/imagenes_compartidas/arrow-rigth.png')" alt="">-->
        <div class="arrow-icon-component"><arrow-right/></div>
      </router-link>
    </button>
  </v-layout>
</template>
<script>
    import ScormMix from '../js/mixins/scormmixins'
    import resourcesLoader from "../js/mixins/resources-loader";
    export default { 
        mixins: [resourcesLoader],
        props:{
            mod: {
              type: Object,
              required: true
            },
        },
        components:{
          ArrowLeft: () => import('./svg/flecha-izq'),
          ArrowRight: () => import('./svg/flecha-der'),
        },
        data() {
            return {
                titulo: '',
                // logo: '',
            }
        },
        methods: {
            getData(data) {
                return data
            },
            getModuleTitle() {
                return this.$store.state.title
            }
        },

        computed: {
            temaName() {
                return this.$store.state.tema;
            },
            subtemaName() {
                console.log('SUBTEMANAME '+this.$store.state.subTema)
                return this.$store.state.subTema;
            },
            showTrack() {
                var routeArr = this.$route.path.split("/");
                console.log('routerArr '+ routeArr)
                if (routeArr.length <= 2) {
                    return false
                } else {
                    return true
                }
            },
            currentPage() {
                return Math.floor(this.$route.params.unipage);
            },
          nextPant() {
            return this.$store.state.nextPant;
          },
          screenTrack() {
            return this.$store.state.screens;
          },
          currentPage() {
            return Math.floor(this.$route.params.unipage);
          }
        },
        watch: {
          screenTrack(val){
            let bar = this.$refs['progressBar']
            let bar2 = this.$refs['progressBar2']
            let pct = ((val[0]+1)/val[1]) * 100
            console.log('pct: '+pct)
            bar.style.width = pct+"%"
            bar2.style.left = pct+"%"
          }
        },
        mixins: [ScormMix]
    }
</script>
<style lang="scss" scoped>
@import '../sass/globals';
*:focus{
    outline: none!important;
}
a{
  text-decoration: none!important;
  color: white;
}
.inactive{
  opacity: 0.2;
  pointer-events: none;
  &:hover{
    cursor:none!important;
  }
}
.kd{
  width: 100%!important;
  display: block;
  height: 100%!important;
  display: flex;

  align-content: center;
  align-items: center;
}
.kd-l{
  justify-content:flex-end;
  padding-right: 30px;
}
.kd-r{
  justify-content: flex-start;
  padding-left: 30px;
}

.anima-icon{
  animation: animaIcon 1s infinite ease-in-out;
}
@keyframes animaIcon {
  0%{transform: translateX(0px);opacity: 0; }
  100%{transform: translateX(10px);opacity: 1;}

}
.navmenu-container{
    width: 100vw;
    height: 60px;
    position: fixed;
    bottom: 0px;
    background: #F4F4F4;
    z-index: 3;
    color: white;
  }

  .progress-container{
    width: 100%;
    height: auto;
    position: absolute;
    top: -4px;
    .page-count{
      width: 100%;
      position: relative;
      padding: 0;
      margin: 0;
      height: 10px;
      font-size: 8pt;
      line-height: 0pt;
      text-align: center;
      span{
        padding: 0;
        margin: 0;

      }
    }
    .progress-bar{
      width: 100%;
      height: 6px;
      background: $color-gray;
      position: relative;
      overflow: hidden;
      margin: 0 auto;
      .bar{
        display: block;
        position: absolute;
        height: 100%;
        bottom: 0%;
        left: 0%;
        background-color: $color-complement-two;
        max-width: 100%;
        transition: width 200ms;
        .circle-bar{
          z-index: 2;
          content: '';
          background: $color-complement-two;
          height: 20px;
          width: 20px;
          border-radius: 50%;
        }
      }
        .progress-bar2 {         
            display: block;
            position: absolute;
            height: 100%;
            top: 0;
            left: 0;
            /*background-color: #FFE300;*/
            width: 100%;
            z-index: -10;
            transition: width 200ms;            
            border-bottom: 3px solid #fff;
        }
    }
    @media screen and (min-width: 700px){
      width: 100%;    
    }
  }
  .btn-nav{
    cursor: pointer;
    padding: 5px 10px;
    height: 100%;
    // border: solid red 2px;
    width: 100%;
    margin-top: 8px;
    //background: linear-gradient(0deg, rgba(199,238,149,1) 0%, rgba(199,238,149,0) 76%);
    .icon{
      color: $color-primary;
      line-height: 20px;
    }

    &:hover{
      a{
        .icon{
          font-size: 3em!important;
        }
      }

    }
  }
.txt-icon{
  font-size: 13pt;
  font-family: FontBase-BoldItalic!important;
}

.circle-bar{
  content: '';
  background: $color-complement-two;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.contenedor-progress-bar{
  display: flex;
  justify-content: end;
  align-items: center;
}
.arrow-icon{
  height: 70%;
}
.arrow-icon-component{
  width: 30px;
}



.triangulo{
  width: 10px; 
  height: 10px; 
  background: $color-secondary;
  /*border-left: 20px solid $color-secondary;
  border-top: 14px solid transparent;
  border-bottom: 13px solid transparent;*/
  position: fixed;
  border-radius: 50%;
  margin-top: -2px;
}

</style>
